import React, { useState, useEffect } from 'react';
import { ReservationForm } from '../types';
import { apiService } from '../services/api';
import './ReserveTableModal.css';

interface ReserveTableModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ReserveTableModal: React.FC<ReserveTableModalProps> = ({ isOpen, onClose }) => {
  const [reservationForm, setReservationForm] = useState<ReservationForm>({
    reserve_name: '',
    from: '',
    mobno: '',
    age: 0,
    person_count: 1,
    party_type: 'Casual Dining',
    date: '',
    time: ''
  });

  useEffect(() => {
    if (isOpen) {
      setMinDate();
    }
  }, [isOpen]);

  const setMinDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const minDate = `${year}-${month}-${day}`;
    
    const dateInput = document.querySelector('.reserve-modal input[type="date"]') as HTMLInputElement;
    if (dateInput) {
      dateInput.min = minDate;
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setReservationForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!reservationForm.reserve_name) {
      alert('Please enter person name');
      return;
    }
    if (!reservationForm.from) {
      alert('Please enter email id');
      return;
    }
    if (!reservationForm.mobno) {
      alert('Please enter mobile no.');
      return;
    }
    if (!reservationForm.age) {
      alert('Please enter your age');
      return;
    }
    if (!reservationForm.party_type) {
      alert('Please select party type');
      return;
    }
    if (!reservationForm.date) {
      alert('Please select date');
      return;
    }
    if (!reservationForm.time) {
      alert('Please select time');
      return;
    }

    try {
      await apiService.submitReservation(reservationForm);
      alert('Reservation submitted successfully!');
      setReservationForm({
        reserve_name: '',
        from: '',
        mobno: '',
        age: 0,
        person_count: 1,
        party_type: 'Casual Dining',
        date: '',
        time: ''
      });
      onClose();
    } catch (error) {
      alert('Reservation submitted! We will contact you soon.');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="reserve-modal-overlay" onClick={onClose}>
      <div className="reserve-modal" onClick={(e) => e.stopPropagation()}>
        <button className="reserve-modal-close" onClick={onClose}>×</button>
        
        <div className="reserve-modal-header">
          <h2>Reserve a Table</h2>
          <p>Bangtan Lounge - Global Eatery & Bar</p>
        </div>

        <form onSubmit={handleSubmit} className="reserve-form">
          <div className="form-row">
            <div className="form-group">
              <label>Name</label>
              <input 
                type="text" 
                name="reserve_name" 
                value={reservationForm.reserve_name}
                onChange={handleInputChange}
                placeholder="Your name"
              />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input 
                type="email" 
                name="from" 
                value={reservationForm.from}
                onChange={handleInputChange}
                placeholder="your@email.com"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Mobile No.</label>
              <input 
                type="number" 
                name="mobno" 
                value={reservationForm.mobno}
                onChange={handleInputChange}
                placeholder="10-digit number"
              />
            </div>
            <div className="form-group">
              <label>Age</label>
              <input 
                type="number" 
                name="age" 
                value={reservationForm.age || ''}
                onChange={handleInputChange}
                placeholder="Your age"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Party Size</label>
              <select 
                name="person_count" 
                value={reservationForm.person_count}
                onChange={handleInputChange}
              >
                {Array.from({length: 20}, (_, i) => (
                  <option key={i + 1} value={i + 1}>{i + 1} {i + 1 === 1 ? 'Person' : 'People'}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Party Type</label>
              <select 
                name="party_type" 
                value={reservationForm.party_type}
                onChange={handleInputChange}
              >
                <option value="Casual Dining">Casual Dining</option>
                <option value="Corporate Party">Corporate Party</option>
                <option value="Filmshoot Party">Filmshoot Party</option>
                <option value="Kitty Party">Kitty Party</option>
                <option value="Birthday Party">Birthday Party</option>
                <option value="Prewedding Shoot">Prewedding Shoot</option>
                <option value="Family Parties">Family Parties</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date</label>
              <input 
                type="date" 
                name="date" 
                value={reservationForm.date}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Time</label>
              <input 
                type="time" 
                name="time" 
                value={reservationForm.time}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <button type="submit" className="reserve-submit-btn">Reserve Table Now</button>
        </form>
      </div>
    </div>
  );
};

export default ReserveTableModal;
